module.exports = __webpack_public_path__ + "static/media/logo-leclerc-header.ec991cdd.svg";